"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RouteTabItem.css");
var react_router_dom_1 = require("react-router-dom");
var RouteTabItem = /** @class */ (function (_super) {
    __extends(RouteTabItem, _super);
    function RouteTabItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RouteTabItem.prototype.render = function () {
        var props = {
            activeClassName: styles.active,
            className: styles.item,
            to: this.props.data.to,
        };
        return (React.createElement(react_router_dom_1.NavLink, __assign({ "data-test-id": this.props.testId }, props), this.props.children));
    };
    return RouteTabItem;
}(React.Component));
exports.default = RouteTabItem;
//# sourceMappingURL=RouteTabItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RouteTabItem/RouteTabItem.js
// module id = 1273
// module chunks = 8